import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const CxcExamRoutingProvider = RouterModule.forRoot(routes, { useHash: true });